module.exports = __webpack_public_path__ + "30d25d428b76b022934c703f29b71350.MP3";